<template>
  <div class="user-guide-wrapper">
    <!-- 返回按钮与标题栏 -->
    <div class="guide-header">
      <div class="header-left">
        <button class="back-button" @click="goBack">
          <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 16 16">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 13L4 8l6-5"/>
          </svg>
          返回
        </button>
      </div>
      <h2 class="header-title">使用指引</h2>
      <div class="header-right">
        <!-- 可添加其他操作按钮，如搜索、设置等 -->
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="content-scroll-wrapper">
      <!-- 折叠面板 -->
      <el-collapse 
        class="guide-collapse" 
        accordion 
        :border="false"
        expand-icon-position="right"
      >
        <!-- 重命名对话标题 -->
        <el-collapse-item 
          name="1" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header">重命名对话标题</span>
          </template>
          <div class="item-content">
            <p class="content-desc">1. 找到需要重命名的历史对话条目，鼠标悬浮至条目上；</p>
            <p class="content-desc">2. 条目右侧会显示「更多操作」按钮（⋮），点击该按钮；</p>
            <p class="content-desc">3. 在弹出的菜单中选择「重命名」选项；</p>
            <p class="content-desc">4. 输入新的对话标题（最多20个字符），点击「确认」完成修改。</p>
          </div>
        </el-collapse-item>

        <!-- 置顶历史对话 -->
        <el-collapse-item 
          name="2" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header">置顶历史对话</span>
          </template>
          <div class="item-content">
            <p class="content-desc">方式一（快捷操作）：</p>
            <p class="content-desc">1. 鼠标右键点击需要置顶的历史对话条目；</p>
            <p class="content-desc">2. 在右键菜单中选择「置顶」选项，条目会自动固定至对话列表顶部。</p>
            <p class="content-desc">方式二（更多操作）：</p>
            <p class="content-desc">1. 悬浮至目标对话条目，点击右侧「更多操作」按钮（⋮）；</p>
            <p class="content-desc">2. 选择「置顶」选项完成操作；</p>
            <p class="content-desc">3. 取消置顶：重复上述步骤，选择「取消置顶」即可。</p>
          </div>
        </el-collapse-item>

        <!-- 删除历史对话 -->
        <el-collapse-item 
          name="3" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header">删除历史对话</span>
          </template>
          <div class="item-content">
            <p class="content-desc">1. 鼠标悬浮至需要删除的对话条目，点击右侧「更多操作」按钮（⋮）；</p>
            <p class="content-desc">2. 选择「删除」选项，会弹出确认删除的提示框；</p>
            <p class="content-desc">3. 点击「确认」后，该对话记录将被永久删除（不可恢复）；</p>
            <p class="content-desc">⚠️ 注意：删除操作仅删除本地展示的对话记录，服务器端历史数据需在「设置-数据管理」中单独清理。</p>
          </div>
        </el-collapse-item>

        <!-- 分享历史对话 -->
        <el-collapse-item 
          name="4" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header">分享历史对话</span>
          </template>
          <div class="item-content">
            <p class="content-desc">1. 打开需要分享的对话详情页；</p>
            <p class="content-desc">2. 点击页面右上角「分享」按钮（🔗）；</p>
            <p class="content-desc">3. 选择分享方式：链接分享 / 图片分享 / 文本分享；</p>
            <p class="content-desc">4. 链接分享：生成临时有效链接（默认24小时），可设置访问密码；</p>
            <p class="content-desc">5. 图片/文本分享：将对话内容导出为图片/纯文本，支持复制或直接分享至微信/QQ。</p>
          </div>
        </el-collapse-item>

        <!-- 导出历史对话 -->
        <el-collapse-item 
          name="5" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header">导出历史对话</span>
          </template>
          <div class="item-content">
            <p class="content-desc">1. 进入目标对话详情页，点击右上角「更多」按钮；</p>
            <p class="content-desc">2. 选择「导出对话」选项，弹出导出格式选择框；</p>
            <p class="content-desc">3. 可选格式：JSON（含完整对话结构）、TXT（纯文本）、PDF（格式化排版）；</p>
            <p class="content-desc">4. 选择格式后点击「导出」，文件会自动下载至本地；</p>
            <p class="content-desc">💡 提示：批量导出可在「历史对话列表-批量操作」中选择多个对话统一导出。</p>
          </div>
        </el-collapse-item>

        <!-- 换绑手机号 -->
        <el-collapse-item 
          name="6" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header">换绑手机号</span>
          </template>
          <div class="item-content">
            <p class="content-desc">1. 进入「个人中心-账号与安全」页面；</p>
            <p class="content-desc">2. 找到「手机号」栏目，点击右侧「换绑」按钮；</p>
            <p class="content-desc">3. 第一步：验证原手机号（接收并填写验证码）；</p>
            <p class="content-desc">4. 第二步：输入新手机号，点击「获取验证码」并填写；</p>
            <p class="content-desc">5. 点击「确认换绑」，新手机号将立即生效；</p>
            <p class="content-desc">⚠️ 注意：每个账号30天内仅可换绑1次手机号。</p>
          </div>
        </el-collapse-item>

        <!-- 换绑微信号 -->
        <el-collapse-item 
          name="7" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header">换绑微信号</span>
          </template>
          <div class="item-content">
            <p class="content-desc">1. 进入「个人中心-账号与安全-第三方绑定」页面；</p>
            <p class="content-desc">2. 找到「微信」栏目，若已绑定则显示「换绑」，未绑定则显示「绑定」；</p>
            <p class="content-desc">3. 点击「换绑」后，先解除当前绑定的微信（需验证登录密码）；</p>
            <p class="content-desc">4. 扫描弹出的二维码，使用新微信号完成授权绑定；</p>
            <p class="content-desc">5. 绑定成功后，页面会提示「换绑完成」，新微信号将作为登录方式之一。</p>
          </div>
        </el-collapse-item>

        <!-- 换绑邮箱 -->
        <el-collapse-item 
          name="8" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header">换绑邮箱</span>
          </template>
          <div class="item-content">
            <p class="content-desc">1. 进入「个人中心-账号与安全」页面；</p>
            <p class="content-desc">2. 找到「邮箱」栏目，点击「换绑」按钮；</p>
            <p class="content-desc">3. 验证登录密码后，输入新邮箱地址；</p>
            <p class="content-desc">4. 点击「发送验证邮件」，前往新邮箱查收验证链接；</p>
            <p class="content-desc">5. 点击邮件中的验证链接，完成邮箱换绑；</p>
            <p class="content-desc">💡 提示：验证邮件有效期为1小时，若未收到可点击「重新发送」。</p>
          </div>
        </el-collapse-item>

        <!-- 一键登出所有设备 -->
        <el-collapse-item 
          name="9" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header">一键登出所有设备</span>
          </template>
          <div class="item-content">
            <p class="content-desc">1. 进入「个人中心-账号与安全-设备管理」页面；</p>
            <p class="content-desc">2. 可查看当前登录的所有设备（设备类型、登录时间、登录地点）；</p>
            <p class="content-desc">3. 点击页面底部「一键登出所有设备」按钮；</p>
            <p class="content-desc">4. 验证登录密码或短信验证码；</p>
            <p class="content-desc">5. 点击「确认」后，除当前设备外，其他所有登录设备将被强制登出；</p>
            <p class="content-desc">⚠️ 注意：操作后需重新登录其他设备，建议在账号异常时使用。</p>
          </div>
        </el-collapse-item>

        <!-- 注销账号 -->
        <el-collapse-item 
          name="10" 
          class="collapse-item"
        >
          <template #title>
            <span class="custom-header custom-header-warning">注销账号</span>
          </template>
          <div class="item-content">
            <p class="content-desc content-warning">⚠️ 重要提示：账号注销后，所有数据（对话记录、会员信息、绑定关系）将被永久删除，且不可恢复！</p>
            <p class="content-desc">注销步骤：</p>
            <p class="content-desc">1. 进入「个人中心-账号与安全-账号注销」页面；</p>
            <p class="content-desc">2. 仔细阅读注销须知，确认后点击「下一步」；</p>
            <p class="content-desc">3. 完成身份验证（短信验证码 + 登录密码）；</p>
            <p class="content-desc">4. 选择注销原因（可选），点击「确认注销」；</p>
            <p class="content-desc">5. 注销申请提交后，账号将进入7天冷静期；</p>
            <p class="content-desc">6. 冷静期内未登录，账号将被永久注销；若登录则自动撤销注销申请。</p>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserGuide",
  data() {
    return {
      // 可扩展：存储折叠面板状态、自定义配置等
    };
  },
  created() {
    // 可扩展：加载个性化指引、用户操作记录等
  },
  methods: {
    // 返回上一层
    goBack() {
      this.$router.go(-1); // 或者使用 this.$router.push('/previous-route')
    },
  },
};
</script>

<style lang="scss" scoped>
// 页面整体样式
.user-guide-wrapper {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px 30px;
  background-color: #f8f9fa;
  min-height: 100vh;
  box-sizing: border-box;
}

// 顶部标题栏样式 - 使用固定定位
.guide-header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  margin-bottom: 24px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  backdrop-filter: blur(8px);
  background-color: rgba(248, 249, 250, 0.95);
  
  @media (max-width: 768px) {
    position: sticky;
    top: 0;
    padding: 12px 0;
    margin-bottom: 20px;
  }
}

// 左侧返回按钮区域
.header-left {
  flex: 0 0 auto;
  
  .back-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #606266;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    &:hover {
      background-color: #f5f7fa;
      border-color: #409eff;
      color: #409eff;
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 4px rgba(64, 158, 255, 0.1);
    }

    .nav-icon {
      width: 16px;
      height: 16px;
      transition: transform 0.2s ease;
    }

    &:hover .nav-icon {
      transform: translateX(-2px);
    }
  }
}

// 中间标题区域
.header-title {
  flex: 1;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  text-align: center;
  line-height: 1.4;
  
  @media (max-width: 768px) {
    font-size: 18px;
    padding: 0 8px;
  }
}

// 右侧区域（占位，保持平衡）
.header-right {
  flex: 0 0 auto;
  width: 88px; // 与左侧返回按钮宽度匹配，保持视觉平衡
  
  @media (max-width: 768px) {
    width: 60px;
  }
}

// 内容滚动容器
.content-scroll-wrapper {
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  padding-right: 8px;
  padding-bottom: 20px;
  
  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
  
  // Firefox滚动条样式
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

// 折叠面板样式
.guide-collapse {
  --el-collapse-header-text-color: #333;
  --el-collapse-header-font-size: 16px;
  --el-collapse-content-font-size: 14px;
  --el-collapse-border-color: transparent;

  .collapse-item {
    margin-bottom: 12px;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    ::v-deep .el-collapse-item__header {
      padding: 16px 20px;
      border-bottom: 1px solid #f0f2f5;
      cursor: pointer;
      display: flex;
      align-items: center;

      &:hover {
        background-color: #f8f9fa;
      }
    }

    ::v-deep .el-collapse-item__content {
      padding: 20px;
      color: #666;
      line-height: 1.8;
    }
  }
}

// 自定义标题样式
.custom-header {
  font-weight: 600;
  color: #303133;
  font-size: 16px;

  &.custom-header-warning {
    color: #e6a23c; // 危险操作使用警告色
  }
}

// 条目内容样式
.item-content {
  .content-desc {
    margin: 0 0 8px 0;
    padding-left: 8px;
    border-left: 2px solid #939ec5;

    &:last-child {
      margin-bottom: 0;
    }

    &:nth-child(1) {
      margin-top: 0;
    }
  }

  .content-desc.content-warning {
    border-left-color: #e6a23c;
    color: #e6a23c;
    font-weight: 500;
  }

  .content-desc:has(> span[style*="color:red"]) {
    font-weight: 500;
    color: #e64340;
  }
}

// 移动端适配
@media (max-width: 768px) {
  .user-guide-wrapper {
    padding: 0 15px 20px;
  }

  .content-scroll-wrapper {
    max-height: calc(100vh - 100px);
  }

  .guide-collapse {
    .collapse-item {
      ::v-deep .el-collapse-item__header {
        padding: 14px 16px;
      }

      ::v-deep .el-collapse-item__content {
        padding: 16px;
      }
    }
  }
}

// 小屏幕设备适配
@media (max-width: 480px) {
  .header-left .back-button {
    padding: 6px 12px;
    font-size: 13px;
    
    .nav-icon {
      width: 14px;
      height: 14px;
    }
  }
  
  .header-title {
    font-size: 16px;
  }
  
  .header-right {
    width: 50px;
  }
}

// 防止底部内容被遮挡
@media (max-height: 600px) {
  .content-scroll-wrapper {
    max-height: calc(100vh - 100px);
  }
}
</style>